var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
// Components
import { TableStructure } from '../components/TableStructure';
// Utils
import styled from 'styled-components';
export var StyledTable = styled(TableStructure)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  border-spacing: 0;\n\n  tbody td {\n    border-bottom: 1px solid ", ";\n  }\n\n  thead th:not(:last-child) {\n    border-right: 1px solid ", ";\n  }\n\n  tr:hover {\n    background-color: ", ";\n  }\n\n  tbody tr {\n    height: 48px;\n  }\n"], ["\n  border-spacing: 0;\n\n  tbody td {\n    border-bottom: 1px solid ", ";\n  }\n\n  thead th:not(:last-child) {\n    border-right: 1px solid ", ";\n  }\n\n  tr:hover {\n    background-color: ", ";\n  }\n\n  tbody tr {\n    height: 48px;\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return "" + theme.borderPrimary;
}, function (_a) {
    var theme = _a.theme;
    return "" + theme.borderPrimary;
}, function (_a) {
    var theme = _a.theme;
    return "" + theme.hoverHighlight;
});
var templateObject_1;
//# sourceMappingURL=StyledTable.js.map